import { SvgIcon, SvgIconProps } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';

// MUI Dns and Https glyph paths (24x24), composited so we render a single SVG root like the other custom icons.
const DNS_PATH =
  'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1M7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1M7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2';
const HTTPS_PATH =
  'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1z';

// Composite connector icon (DNS over HTTPS): the DNS glyph as the base with a smaller HTTPS lock centered
// on top (translated + scaled to 0.36). The lock has a white paint-order stroke so it reads over the DNS shape.
const DohIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d={DNS_PATH} />
    <g transform="translate(7.68 7.68) scale(0.36)">
      <path d={HTTPS_PATH} stroke="white" strokeWidth={2} paintOrder="stroke" />
    </g>
  </SvgIcon>
);

(DohIcon as OverridableComponent<SvgIconTypeMap<object, 'svg'>> & { muiName: string }).muiName =
  'DohIcon';

export default DohIcon as OverridableComponent<SvgIconTypeMap<object, 'svg'>> & {
  muiName: string;
};
